/* eslint-disable import/no-unused-modules */
import React from 'react';

import { IconStyled } from './styles';
import { IconProps } from './types';

export const Icon = ({ icon, variant }: IconProps): JSX.Element => <IconStyled icon={icon} variant={variant} />;
